import React from 'react';
import PropTypes from 'prop-types';

import { useStore } from 'core/store';
import { Label } from 'core/components/label';
import { getErrorData } from 'common/constants/get-error-data';
import useStyles from './dialog.styles';

const DialogError = ({ error, rawError }) => {
  const classes = useStyles();

  const { offer: offerStore } = useStore();
  const state = offerStore.state;
  const errorObject = getErrorData({
    error,
    state,
    errorType: 'REJECTION'
  });

  const errorMessage = errorObject?.policyErrorMessage || errorObject?.why;

  return (
    <div className={classes.errorContent}>
      {errorObject && (
        <>
          {errorObject.title && (
            <Label type="infoSubtitle" className={classes.errorTitle}>
              Error {errorObject.code} - {errorObject.title}
            </Label>
          )}
          {errorMessage && (
            <Label type="infoValue" className={classes.errorMessage}>
              {errorMessage}
            </Label>
          )}
        </>
      )}
      {rawError && !errorObject && (
        <Label type="infoValue" className={classes.errorMessage}>
          {rawError}
        </Label>
      )}
    </div>
  );
};

DialogError.propTypes = {
  error: PropTypes.object.isRequired,
  isRejection: PropTypes.bool
};

DialogError.defaultProps = {
  isRejection: false
};

export default DialogError;
